export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATEA5_EN.47d7ead9.png";